import { render, staticRenderFns } from "./FinanceMarginWidget.vue?vue&type=template&id=1887f87c"
import script from "./FinanceMarginWidget.vue?vue&type=script&lang=js"
export * from "./FinanceMarginWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports